import React, { Component } from "react";
import { Buffer } from "buffer";
import axios from "axios";
// import { Link } from "react-router-dom";

import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// ============ Miscellaneous Files ============
import Navbar from "./components/navbar";
import Results from "./components/results";
import "./stylesheets/App.css";
// import "../stylesheets/style.css";
// import "../App.css";

// ============ MDB Components ============
import { MDBContainer, MDBInput, MDBSpinner } from "mdb-react-ui-kit";

class JobCardSearch extends Component {
  state = {
    results: {},
    startDate: null,
    endDate: null,
    formattedStartDate: "",
    formattedEndDate: "",
  }

  // Initializaions
  async componentDidMount() {
    const spinner = document.querySelector(".spinner");
    spinner.style.display = "flex";

    const tosField = document.querySelector(".type-of-service");
    if (tosField.length === 1) {
      let tos = [];
      const url = "https://p4d-sutlej.kreativit.in:443/kitmyclients-apis/v1/business_data_manager/RSCS/reference?name=dropdown";
      await axios(url, {
        headers: {
          Authorization: "Basic " + Buffer.from("RSCS_admin:admin@scsr").toString("base64"),
          "Auth-Token": "5905d234-34f7-53ce-b192-a886192134ca",
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      })
        .then(res => res.data)
        .then(res => {
          tos = res.data["service-types"];
        })
        .catch(err => console.log(err));

      let i, len = tos.length;
      for (i = 0; i < len; i++) {
        tosField.innerHTML += `<option value="${tos[i]}">${tos[i]}</option>`;
      }
    }

    spinner.style.display = "none";
  }

  months = ["-1", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  formatDate(date) {
    if (!(date instanceof Date) && /[a-zA-Z]/g.test(date)) { // then it is called with a Date as parameter
      date = date.substring(7).toString() + "-" + this.months.indexOf(date.substring(3, 6)).toString().padStart(2, "0") + "-" + date.substring(0, 2).toString().padStart(2, "0");
      return date;
    }
    return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0");
  }

  // Results
  showResults = async () => {
    const jobcardno = document.querySelector(".job-card-number").value;
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    const formattedStartDate = this.state.formattedStartDate;
    const formattedEndDate = this.state.formattedEndDate;

    if (startDate === null && endDate !== null) {
      alert("Please Provide Start Date");
      this.setState({ results: [] });
      return;
    }

    if (startDate !== null && endDate === null) {
      alert("Please Provide End Date");
      this.setState({ results: [] });
      return;
    }

    if (startDate > endDate) {
      alert("Not Allowed: Start date is more than End date.");
      this.setState({ results: [] });
      return;
    }

    const spinner = document.querySelector(".spinner");
    spinner.style.display = "flex";
    const typeOfService = document.querySelector(".type-of-service").value;

    let url = "https://p4d-sutlej.kreativit.in:443/kitmyclients-apis/v1/business_data_manager/RSCS/transactionals?name=vehicle_job_card";
    if (jobcardno !== "") url += "&job-card-no=" + jobcardno;
    if (typeOfService !== "all") url += "&type-of-service=" + typeOfService;

    await axios.get(url, {
      headers: {
        Authorization: "Basic " + Buffer.from("RSCS_admin:admin@scsr").toString("base64"),
        "Auth-Token": "5905d234-34f7-53ce-b192-a886192134ca",
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then(res => res.data)
      .then(res => {
        let i, data = res.data, dataLength = data.length, result = [], submitDate;
        if (dataLength > 0) {
          // If no inputs are given, all the job cards must be displayed
          if (jobcardno === "") {
            if (startDate === null && endDate === null) {
              data.forEach((datum) => result.push(datum));
            } else {
              data.forEach((datum) => {
                submitDate = this.formatDate(datum["submit-date"]);
                if (formattedStartDate <= submitDate && submitDate <= formattedEndDate) {
                  result.push(datum);
                }
              });
            }
          } else {
            if (startDate === null && endDate === null) {
              for (i = 0; i < dataLength; i++) {
                if (jobcardno === data[i]["job-card-no"]) {
                  result.push(data[i]);
                  break;
                }
              }
            } else {
              for (i = 0; i < dataLength; i++) {
                submitDate = this.formatDate(data[i]["submit-date"]);
                if (jobcardno === data[i]["job-card-no"] && formattedStartDate <= submitDate && submitDate <= formattedEndDate) {
                  result.push(data[i]);
                  break;
                }
              }
            }
          }
        } else {
          result = [];
        }
        this.setState({ results: result });
      })
      .catch((err) => console.log(err));
    spinner.style.display = "none";
  };

  checkForInput = (e) => {
    if (e.keyCode === 13) {
      this.showResults();
    }
  }

  setFromDate = (date) => {
    this.setState({
      formattedStartDate: this.formatDate(new Date(date)),
      startDate: date
    });
  };

  setToDate = (date) => {
    this.setState({
      formattedEndDate: this.formatDate(new Date(date)),
      endDate: date
    });
  };

  render() {
    return (
      <MDBContainer>
        {/* ============= Spinner (or) Loader ============= */}
        <MDBContainer className="spinner">
          <MDBSpinner className="me-2" color="dark" style={{ width: "5rem", height: "5rem" }}></MDBSpinner>
        </MDBContainer>

        {/* ============= Navbar ============= */}
        <Navbar />

        {/* ============= Filters Section ============= */}
        <MDBInput className="job-card-number mb-3" onKeyUp={(e) => this.checkForInput(e)} style={{ marginTop: 15, marginBottom: 15 }} label="Job Card Number" type="text" />

        <div>
          <strong style={{ "minWidth": "135px" }}>Type of Service: </strong>
          <select className="custom-select type-of-service my-2" style={{ "minWidth": "162px" }} >
            <option value="all">--  Select --</option>
          </select>
        </div>

        <div className="my-2">
          <strong><u>Please select date range :</u></strong>

          <div className="d-flex align-items-center">
            <strong style={{ "minWidth": "100px" }}>Start Date: </strong>
            <ReactDatePicker
              placeholderText="DD-MM-YYYY"
              className="my-2 date"
              selected={this.state.startDate}
              onChange={(date) => this.setFromDate(date)}
              maxDate={new Date()}
              dateFormat="dd-MM-yyyy"
              showDisabledMonthNavigation
            />
          </div>

          <div className="d-flex align-items-center">
            <strong style={{ "minWidth": "100px" }}>End Date: </strong>
            <ReactDatePicker
              placeholderText="DD-MM-YYYY"
              className="my-2 date"
              selected={this.state.endDate}
              onChange={(date) => this.setToDate(date)}
              maxDate={new Date()}
              dateFormat="dd-MM-yyyy"
              showDisabledMonthNavigation
            />
          </div>
        </div>

        <div className="text-end my-4">
          <svg onClick={this.showResults} style={{ height: "30px", cursor: "pointer" }} viewBox="0 0 512 512"><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z" /></svg>
        </div>

        {/* ============= Results Section ============= */}
        <Results results={this.state.results} />
      </MDBContainer>
    );
  }
}

export default JobCardSearch;
